import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector } from '../hooks';
export const ConfigSensors = () => {
    const sensors = useAppSelector(state => state.sensors);
    const devices = useAppSelector(state => state.definitions.devices);
    const rows = [];
    Object.values(sensors).forEach(deviceState => {
        const device = devices[deviceState.id];
        if (device && device.protocol.name == 'mandolyn') {
            rows.push(_jsxs("div", { children: [_jsx("div", { children: device.title }), _jsx("div", { children: device.protocol.code })] }, deviceState.id));
        }
    });
    return (_jsx("div", { className: "page-container", children: _jsx("div", { className: "config-rows config-sensors", children: rows }) }));
};
